import styled from "styled-components";
import * as RNEA from "fp-ts/ReadonlyNonEmptyArray";
import * as M from "@discovery/prelude/lib/data/maybe";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { Fold } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import { SonicImage } from "../../components/atoms/sonic-image";
import { GenericCarousel } from "../../components/molecules/generic-carousel";
import { GoToNext, GoToPrev } from "./nav-button";
import { brandlight, neutral10, neutral9 } from "../../css/colors";
import { secondaryFontFamily, primaryFontFamilyBold, primaryFontFamily, } from "../../styles/fontFamilyTypes";
import { media } from "../../styles/breakpoints";
import { Container78VW, AlignCenter } from "../../styles/common";
import { _Show2DefaultImageAttributes } from "../optics";
import * as stylesCarousel from "./carousel.css";
import { LineClamp } from "../../styles/mixins";
const BASIC = "basic";
const DEFAULT_ADVANCE_TIME_S = 2000;
const _ShowDetails = Fold.compose(Optics._Col2Items, Optics._ColItem2Show, Fold.liftM((att, images) => ({ name: att.name, descM: att.description, images }), Optics._Show2Attributes, _Show2DefaultImageAttributes));
const Container = styled(Container78VW) `
  margin: 0px auto 75px auto;

  @media ${media.medium.down} {
    margin: 0px auto 40px auto;
  }
`;
export const Title = styled.span `
  font-family: ${primaryFontFamilyBold};
  font-size: 32px;
  color: ${neutral10};
  text-align: center;
  padding: 35px 0px;
  line-height: 1.37;

  @media ${media.small.down} {
    font-size: 16px;
  }

  @media ${media.xsmall.down} {
    padding: 24px 30px;
  }
`;
const DetailsTitle = styled.span `
  font-family: ${secondaryFontFamily};
  font-size: 32px;
  color: ${neutral10};
  ${LineClamp(1)};
  @media ${media.small.down} {
    font-size: 16px;
  }
`;
const Desc = styled.span `
  font-family: ${primaryFontFamily};
  color: ${neutral9};
  font-size: 16px;
  line-height: 1.63;
  padding-top: 6px;
  ${LineClamp(3)}
  @media ${media.medium.down} {
    text-align: center;
    margin: 0px 80px;
  }
  @media ${media.small.down} {
    text-align: center;
    font-size: 14px;
    margin: 0px;
    ${LineClamp(3)};
  }
`;
const Background = styled.div `
  display: flex;
  flex-direction: row;
  background-color: ${brandlight};
  padding: 44px;
  border-radius: 6px;

  @media ${media.medium.down} {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  @media ${media.small.down} {
    padding: 10px 10px 60px 10px;
  }
`;
const DetailsContainer = styled.div `
  width: 20vw;
  margin-right: 80px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  @media ${media.large.down} {
    margin-right: 40px;
    width: 30vw;
  }
  @media ${media.medium.down} {
    margin-right: 0px;
    margin-top: 15px;
    width: 80vw;
    align-items: center;
  }
`;
const ShowImageContainer = styled.div `
  width: 48vw;
  min-height: 27.5vw;

  @media ${media.large.down} {
    width: 50vw;
  }

  @media ${media.medium.down} {
    width: 82vw;
    height: 45vw;
  }
`;
const TabletDetailsWrapper = styled.div `
  display: block;
  height: 12vw;
  @media ${media.medium.up} {
    display: none;
  }
  @media ${media.xsmall.down} {
    height: 17vw;
  }
`;
const DesktopDetailsWrapper = styled.div `
  display: flex;
  @media ${media.medium.down} {
    display: none;
  }
`;
const getProps = (data) => {
    const titleM = Fold.view(Optics._ColAttributes2Title, data);
    const templateIdM = Fold.preview(Optics._Col2TemplateId, data);
    const showM = Fold.toArray(_ShowDetails, data);
    return {
        templateIdM,
        titleM,
        showM,
    };
};
const FeaturedShowRail = ({ templateIdM, titleM, showM }) => {
    const templateId = M.fromMaybe(templateIdM, "");
    const Details = ({ item, }) => {
        return (React.createElement(DetailsContainer, null,
            React.createElement(DetailsTitle, null, item.name),
            React.createElement(RenderMaybe, null, M.map((desc) => (desc ? React.createElement(Desc, null, desc) : ""), item.descM))));
    };
    const BasicView = () => {
        const carouselSlideL = showM.map((item) => () => {
            return (React.createElement(Background, null,
                React.createElement(DesktopDetailsWrapper, null,
                    React.createElement(Details, { item: item })),
                React.createElement(ShowImageContainer, null,
                    React.createElement(SonicImage, { image: item.images, className: "cover-image", imageSizes: {
                            default: [48, "vw"],
                            maxWidthMediaQueries: [
                                [1023, "px", 80, "vw"],
                                [1439, "px", 50, "vw"],
                            ],
                        }, style: { borderRadius: 6, width: "100%" }, fallbackImageSize: { width: 832 }, alt: "cover" })),
                React.createElement(TabletDetailsWrapper, null,
                    React.createElement(Details, { item: item }))));
        });
        const carouselSlideLNE = RNEA.fromReadonlyArray(carouselSlideL);
        return (React.createElement(Container, null,
            React.createElement(AlignCenter, null,
                React.createElement(RenderMaybe, null, M.map((title) => (title ? React.createElement(Title, null, title) : ""), titleM))),
            React.createElement(RenderMaybe, null, M.map((carouselItemNEL) => (React.createElement(GenericCarousel, { itemL: carouselItemNEL, autoAdvanceIntervalSec: DEFAULT_ADVANCE_TIME_S, classNames: stylesCarousel, NextButton: GoToNext, PrevButton: GoToPrev })), carouselSlideLNE))));
    };
    switch (templateId) {
        case BASIC:
            return React.createElement(BasicView, null);
        default:
            return React.createElement(React.Fragment, null);
    }
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, FeaturedShowRail);

